import { useReveal } from '../hooks/useReveal.js';

/** Gold cross flanked by hairlines that draw inward when revealed. */
export function Ornament({ symbol = '✦' }: { symbol?: string }) {
  const ref = useReveal<HTMLDivElement>(0.3);
  return (
    <div ref={ref} className="ow-ornament my-12" aria-hidden="true">
      <span className="ow-ornament-line ow-ornament-line-l" />
      <span
        className="font-display text-gold text-lg leading-none"
        style={{ letterSpacing: '0.4em' }}
      >
        {symbol}
      </span>
      <span className="ow-ornament-line ow-ornament-line-r" />
    </div>
  );
}
